import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeModalAction } from '../../actions/modal'
import { Buttons } from '../../common/Buttons'
import { buttonClass } from '../../common/CSS'
import { gstValidation } from '../../actions/user'
import { addAmountToWallet } from '../../actions/wallet'
import FormContextApi from '../../ContextApi'


export function GstNumberModal({ setaccess, customer_id }) {
      const { walletValue } = useContext(FormContextApi)
      const [gstNumber, setgstNumber] = useState("")
      const { modalLoading } = useSelector(store => store.loadingreducer)
      const { formButtonLoading } = useSelector(store => store.loadingreducer)
      const { wallet } = useSelector(store => store.walletreducer)
      const [error, setError] = useState(undefined)
      const dispatch = useDispatch()
      const formName = "skipGst"
      const handleCancel = () => {

            setaccess({ pageacces: false, paymentacces: true, gstModal: 'stop' });
            if (wallet?.wallet_amount < walletValue) {
                let money = wallet?.wallet_amount >= walletValue ? walletValue : walletValue - wallet?.wallet_amount;

                dispatch(addAmountToWallet({ orderAmount: money + 432, formName: formName }));
            } else {
                dispatch(closeModalAction());
            }
      }

      const onChangehandled = (event) => {
            if (error?.length > 0) {
                  setError(undefined)
            }
            const { value } = event.target ? event.target : event;
            setgstNumber(value)
      }

      const handleSubmit = () => {
            if (gstNumber.length === 15) {
                  dispatch(gstValidation(gstNumber, customer_id))
            } else {
                  setError("Please enter valid number")
            }
      }
      return (
            <>
                  <div className='py-2 my-6' >
                        <input name="gst_number" placeholder='Enter your GST Identification Number' className='border-2 w-94% px-2 py-2 mx-4 text-2xl modelInput' onChange={onChangehandled} />
                        {error && <span className="text-scogoRed text-base font-normal ml-4 mt-4">{error}</span>}
                        <div className='w-94% m-auto text-right mt-8 modelContainerButton' >
                              <Buttons btnText="Submit" loading={modalLoading} classN={`${buttonClass?.scogoOrange} w-32 rounded-md pt-2 pb-2 mr-6 `} onClick={() => {
                                    handleSubmit()
                              }} />
                              <Buttons btnText="Skip" loading={formButtonLoading[formName]} classN={`${buttonClass?.scogoPrimary} w-32 pt-2 pb-2 `} onClick={() => {
                                    handleCancel()
                              }} />
                        </div>
                  </div>

            </>
      )
}
